import { render } from "./SubmitBio.vue?vue&type=template&id=05491b63"
import script from "./SubmitBio.vue?vue&type=script&lang=js"
export * from "./SubmitBio.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__